import moment from 'moment';
import api from '@/api';
import token from '@/authenticator/token';
import authenticator from '@/authenticator/password';
import Context from '@/models/Context';
import Membership from '@/models/core/Membership';

const state = {
  isLoading: false
};

const getters = {
  isLoading(state) {
    return state.isLoading;
  }
};

// actions
const actions = {
  init({ commit, dispatch }) {
    commit('setLoading', true);

    Context.create({
      data: {
        id: 'current',
        domain: location.hostname
          .split('.')
          .shift()
          .split('-')
          .shift(),
        host:
          location.host.split('.').length <= 1
            ? location.host
            : location.host
                .split('.')
                .slice(1)
                .join('.')
      }
    });

    dispatch('entities/users/get', {}, { root: true }).then(() => {
      dispatch('entities/features/init', {}, { root: true }).then(() => {
        commit('setLoading', false);
      });
    });
  },

  setUser({ commit }, value) {
    commit('setLoading', true);
    Context.update({
      where: context => {
        return context.id === 'current';
      },
      data: { user_id: value }
    }).then(() => {
      commit('setLoading', false);
    });
  },

  check({ commit, dispatch }) {
    token.check();
  },

  composerTemplate({ commit, dispatch }, value) {
    Context.update({
      where: context => {
        return context.id === 'current';
      },
      data: { composerTemplate: value }
    });
  },

  logout({ commit, dispatch }) {
    commit('setLoading', true);
    return new Promise(resolve => {
      token.reset();
      dispatch('entities/groups/reset', {}, { root: true });
      dispatch('entities/memberships/reset', {}, { root: true });
      dispatch('entities/invites/reset', {}, { root: true });
      dispatch('entities/items/reset', {}, { root: true });
      dispatch('entities/sources/reset', {}, { root: true });
      dispatch('entities/deleteAll', {}, { root: true });
      dispatch('entities/context/init', {}, { root: true });
      resolve();
    }).then(() => {
      commit('setLoading', false);
    });
  }
};

// mutations
const mutations = {
  setLoading(state, value) {
    state.isLoading = value;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
